var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sortObj && _vm.sortObj.field === _vm.field)?_c('font-awesome-icon',{attrs:{"icon":_vm.iconClass}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }